import { render } from "./p-search-table.vue?vue&type=template&id=0da09bfe&scoped=true"
import script from "./p-search-table.vue?vue&type=script&lang=js"
export * from "./p-search-table.vue?vue&type=script&lang=js"

import "./p-search-table.vue?vue&type=style&index=0&id=0da09bfe&scoped=true&lang=scss"
import "./p-search-table.vue?vue&type=style&index=1&id=0da09bfe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da09bfe"]])

export default __exports__